
(() => {
  'use strict';

  if (window.NeakasaCwillPoints) return;

  const observers = new WeakMap();
  const selector = '.bm_product_points';

  function syncPoints(container) {
    const priceBlock = container.querySelector(
      '.product-block--price'
    );

    if (!priceBlock) return;

    const discount = priceBlock.querySelector(
      '[data-save-price]'
    );

    if (!discount) return;

    const appBlock = Array.from(
      container.querySelectorAll(
        '.shopify-block.shopify-app-block'
      )
    ).find(block => block.querySelector(selector));

    if (!appBlock) return;

    if (
      appBlock.parentElement !== priceBlock ||
      appBlock.previousElementSibling !== discount
    ) {
      discount.insertAdjacentElement(
        'afterend',
        appBlock
      );
    }

    const bubble = appBlock.querySelector(
      '.bm_div_product_points'
    );

    if (!bubble) return;

    /* 同步折扣标签实际样式 */
    const style = getComputedStyle(discount);

    [
      'fontSize',
      'fontWeight',
      'fontFamily',
      'lineHeight',
      'letterSpacing',
      'paddingTop',
      'paddingRight',
      'paddingBottom',
      'paddingLeft',
      'borderRadius',
      'height',
      'minHeight'
    ].forEach(property => {
      const value = style[property];

      if (bubble.style[property] !== value) {
        bubble.style[property] = value;
      }
    });

    bubble.style.boxSizing = 'border-box';
    bubble.style.alignItems = 'center';
  }

  function init() {
    document.querySelectorAll(
      '[data-product-blocks]'
    ).forEach(container => {
      syncPoints(container);

      if (observers.has(container)) return;

      const observer = new MutationObserver(
        mutations => {
          const structureChanged = mutations.some(
            mutation => mutation.type === 'childList'
          );

          if (structureChanged) {
            syncPoints(container);
          }
        }
      );

      observer.observe(container, {
        childList: true,
        subtree: true
      });

      observers.set(container, observer);
    });
  }

  let scheduled = false;

  function scheduleInit() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      init();
    });
  }

  function start() {
    init();

    /* CWILL 异步渲染支持 */
    const pageObserver = new MutationObserver(
      scheduleInit
    );

    pageObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.addEventListener(
      'resize',
      scheduleInit,
      { passive: true }
    );

    document.addEventListener(
      'shopify:section:load',
      scheduleInit
    );

    document.addEventListener(
      'variant:change',
      scheduleInit
    );
  }

  window.NeakasaCwillPoints = {
    init: scheduleInit
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();
